import { shortenNumber } from "_common/utils";
import Image             from "_components/atoms/image";
import Typography        from "_components/atoms/typography";
import Header            from "_components/templates/homepage/header";

import useStyles from "./styles";

const component = ( { title, sesstionList = [], streamCount, uniqueViews, isCategoryPage, onClickViewMore } ) => {
	const { classes } = useStyles ( { isCategoryPage } );

	const headerInfo = (
		<div className = { classes.headerInfoContainer }>
			<div className = { classes.avatarListContainer }>
				{sesstionList.map ( session => (
					<Image
						key       = { session?.id }
						className = { `${ classes.avatar }` }
						src       = { session?.broadcaster?.sportsFan?.photo }
					/>
				)
				) }
			</div>

			<div className = { classes.statsContainer }>
				<Typography
					className = { classes.liveCount }
					color     = "secondary"
					title     = { `${ shortenNumber ( streamCount ) } Live` }
				/>

				<div className = { classes.ellipse } />

				<Typography
					className = { classes.liveCount }
					color     = "secondary"
					title     = { `${ shortenNumber ( uniqueViews ) } Views` }
				/>
			</div>
		</div>
	);

	if ( isCategoryPage ) {
		return (
			<div className = { `${ classes.fixedHeaderContainer }` }>
				<div className = { classes.headerContent }>
					<Typography className = { classes.title }
						title                = { title }
					/>

					{headerInfo}
				</div>

			</div>
		);
	}

	return (
		<div className = { `${ classes.headerContainer }` }>
			<Header
				onClickViewMore = { onClickViewMore }
				title           = { title }
				titleClass      = { classes.titleClass }
			/>

			{headerInfo}
		</div>
	);
};

export default component;